module.exports = __webpack_public_path__ + "img/new_pipeline_banner_03.72d855d9.jpg";